import useTransferRoute from './useTransferRoute';
import useTransportLocationGetByID from "./useTransportLocationGetByID";
interface TransferRouteGetArrivalParams {
    cityId?: number;
    arrivalLocationFrom?: number;
    arrivalLocationTo?: number;
    execute?: boolean;
}
/**
 * Hook to get transfer routes for ARRIVAL
 * Wraps the generic useTransferRoute hook with specific names for ARRIVAL
 */
export default function useTransferRouteGetArrival(
    params: TransferRouteGetArrivalParams,
) {
    const { cityId, arrivalLocationFrom, arrivalLocationTo, execute = true } = params;

    // Get individual locations to verify parentLocation
    const { data: fromLocation } = useTransportLocationGetByID(
      arrivalLocationFrom,
      { execute: !!arrivalLocationFrom }
    );
    const { data: toLocation} = useTransportLocationGetByID(
      arrivalLocationTo,
      { execute: !!arrivalLocationTo }
    );

    // Wait for both locations to finish loading before executing
    const bothLocationsLoaded = (!!arrivalLocationFrom ? !!fromLocation : true) &&
                                (!!arrivalLocationTo ? !!toLocation : true);

    return useTransferRoute({
        cityId,
        locationFrom: fromLocation,
        locationTo: toLocation,
        execute: execute && bothLocationsLoaded,
    });
}
